import store from "../store";

export function getUserToken() {
  return localStorage.getItem('user-token')
}

export function isWorker() {
  return store.state.user.isWorker && localStorage.getItem('isWorker')
}
export function checkIsProductionServer() {
  return process.env.NODE_ENV === 'production'
}
export function checkIsDevelopmentServer() {
  return process.env.NODE_ENV === 'development'
}
export function isAuthenticated() {
  return store.state.user.isAuthenticated && localStorage.getItem('user-token')
}
export function clearUserAuth(){
  localStorage.removeItem('user-token'); // clear your user's token from localstorage
  localStorage.removeItem('isWorker');
  localStorage.removeItem('username');
  localStorage.removeItem('user-uid');
  window.$cookies.remove("userMuctr");
  store.commit('user/AUTH_LOGOUT')
}
export function isAliveToken() {
  const host_account = process.env.VUE_APP_API_HOST + process.env.VUE_APP_ACCOUNTS_PREFIX;
  let url = host_account + 'authenticate/token/alive/';

  if (window.$cookies.isKey('userMuctr')) {

    var userMuctr = window.$cookies.get("userMuctr");

    localStorage.setItem('user-token', userMuctr.userToken); // store the token in localstorage
    localStorage.setItem('username', userMuctr.userName);
    localStorage.setItem('user-uid', userMuctr.userUid);

    let value = {
      token: userMuctr.userToken
    }
    makePostRequest(url, value).then(resp => {
      if (!resp.ok) {
        throw Error(resp.statusText);
      }
      return resp.json()
    })
      .then(json => {

        if (json.alive === false) {
          store.commit('leftmenu/dissable');
          // localStorage.removeItem('user-token'); // clear your user's token from localstorage
          // localStorage.removeItem('isWorker');
          // localStorage.removeItem('username');
          // window.$cookies.remove("userMuctr");
        }else{
          store.commit('user/AUTH_SUCCESS', {token: userMuctr.userToken, username: userMuctr.userName})
          // this.$store.commit('leftmenu/replaceInstances', getInstMenu());
        }

      }).catch(error => {
      // this.$store.commit('leftmenu/dissable');
      //чистим по ошибке
      // localStorage.removeItem('user-token'); // clear your user's token from localstorage
      // localStorage.removeItem('isWorker');
      // localStorage.removeItem('username');
      // window.$cookies.remove("userMuctr");

    });

  }
  else{
    // window.open(process.env.VUE_APP_LOGIN_HOST);
  }
}

export function getUserUid() {
    return localStorage.getItem('user-uid');
}
export function getGuestUserUid() {
    return localStorage.getItem('guest-token')
}

export function isAdminPermission() {
  let roleArr = localStorage.getItem('role').split(",");
  let answ = roleArr.find(obj => obj === '0')
  return answ;
}
export function isOnlyReadPermission() {
  let roleArr = localStorage.getItem('role').split(",");
  let answ = roleArr.find(obj => Number(obj) >  2)
  return answ;
}
export function getPermission() {
  let roleArr = localStorage.getItem('role').split(",");
  return roleArr;
}

export function getHttpHeaders() {
  let headers = {
    'Content-Type': 'application/json',
  }
  if (getGuestUserUid())
    headers['roleToken'] = getGuestUserUid()
  if (getUserToken())
    headers['Authorization'] = 'Token ' + getUserToken()
  // console.log(headers)
  return headers
}

export function getHttpHeadersFile() {
  let headers = {}// 'Content-Type': 'multipart/forms-data',}
  if (getUserToken())
    headers['Authorization'] = 'Token ' + getUserToken()
  if (getGuestUserUid())
    headers['roleToken'] = getGuestUserUid()
  return headers
}

export function makeGetRequest(url, addheaders) {
  let headers = getHttpHeaders();
  return fetch(url, {
    headers: headers,
    method: 'GET',
  });
}

export function makePostRequest(url, data, method, addheadres) {
  let headers = getHttpHeaders()
  if (!method)
    method = 'POST'
  return fetch(url, {
    headers: headers,
    method: method,
    body: JSON.stringify(data),
  });
}

export function makePostRequestFile(url, data, method, addheadres) {
  let headers = getHttpHeadersFile()
  if (!method)
    method = 'POST'
  return fetch(url, {
    headers: headers,
    method: method,
    body: data,
  });
}

export function makeUpdateRequest(url, data, addheaders) {
  let headers = getHttpHeaders()
  return fetch(url, {
    headers: headers,
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export function makeParticalUpdateRequest(url, data, addheaders) {
  return makePostRequest(url, data, "PATCH")
}

export function makeDeleteRequest(url, data) {
  return makePostRequest(url, data, 'DELETE')
}

export function makeProfileUrl(url) {
  return url.replace('<user-uid>', getUserUid()).replace('<uuid:user>', getUserUid()).replace('<user>', getUserUid());
}

export function getInstMenu() {
  let instances = [
    //{title: 'Профиль', icon: 'account_box', router: 'Profile', name: 'accounts',},

  ];
  return instances
}

export function loadCookies() {

}

export function makeManagerUrl(url, manager) {
  return url.replace('<manager-uid>', manager);
}

